export default "__VITE_ASSET__1eaa5eb7__"